import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { omit, compose, hashArray } from '@elliemae/ds-utilities/utils';
import * as tree from 'treetabular';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var getHierarchyTypeName = function getHierarchyTypeName(dest) {
  return !dest ? 'hierarchy' : 'hierarchyDest';
};
var checkHasChildren = function checkHasChildren(list, currentItem) {
  return list.some(function (item) {
    return currentItem.id === item.parent;
  });
};
var getActiveIdFromHierarchy = function getActiveIdFromHierarchy() {
  var hierarchy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return hierarchy[hierarchy.length - 1] || {};
};
var filterItemsByHierarchy = function filterItemsByHierarchy(list, hierarchyId) {
  var parentField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'parent';
  return list.filter(function (item) {
    return item[parentField] === hierarchyId;
  });
};
var getItemsById = function getItemsById(ids, list) {
  return ids.reduce(function (acc, id) {
    return acc.concat(list.find(function (item) {
      return String(item.id) === String(id);
    }));
  }, []).filter(function (item) {
    return item;
  });
};
var toggleInObject = function toggleInObject(obj, key, value) {
  return obj[key] ? omit(obj, [key]) : _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, value));
};
var isMovable = function isMovable(item) {
  return !item.forceNotMovable && (item.hasChildren && item.isMoveableContainer || !item.hasChildren);
}; // utility to execute all specified actions in sequence

var pipe = function pipe(actions) {
  return function (initState, props) {
    return actions.reduce(function (prevState, action) {
      return action(prevState, props);
    }, initState);
  };
};
var moveItems = function moveItems(_ref) {
  var oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex;
  return function (items) {
    var sourceItem = items[oldIndex];
    items.splice(oldIndex, 1);
    items.splice(newIndex, 0, sourceItem);
    return items;
  };
};
var prepareItems = function prepareItems(items) {
  return compose(tree.fixOrder(), function (items) {
    return items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        hasChildren: checkHasChildren(items, item)
      });
    });
  })(items);
};
var defaultOptions = {
  parentField: 'parent',
  idField: 'id',
  op: function op(hasMoved) {
    return !hasMoved;
  }
};
function getChildrenFromParent(parentId, options) {
  var _defaultOptions$optio = _objectSpread(_objectSpread({}, defaultOptions), options),
      parentField = _defaultOptions$optio.parentField;

  return function (items) {
    return items.filter(function (item) {
      return item[parentField] === parentId;
    });
  };
}
function filterMovedItems(movedItems, options) {
  var _defaultOptions$optio2 = _objectSpread(_objectSpread({}, defaultOptions), options),
      idField = _defaultOptions$optio2.idField,
      filterOp = _defaultOptions$optio2.op;

  var movedItemsHash = hashArray(movedItems, idField);
  return function (items) {
    return items.filter(function (item) {
      return filterOp(!!movedItemsHash[item[idField]]);
    });
  };
}
function filterBySearch(term, searching) {
  return function (items) {
    return searching ? items.filter(function (item) {
      return item.name.toLowerCase().indexOf(String(term).toLowerCase()) !== -1;
    }) : items;
  };
}

export { checkHasChildren, filterBySearch, filterItemsByHierarchy, filterMovedItems, getActiveIdFromHierarchy, getChildrenFromParent, getHierarchyTypeName, getItemsById, isMovable, moveItems, pipe, prepareItems, toggleInObject };
//# sourceMappingURL=helper.js.map
